import swup, { fragmentPlugin } from "../entrypoints/swup";
import { animate } from "motion";

export const store = {
  visible: false,
  productUrl: null,
  scrollPosition: 0,
  contentReplace: () => {},
  init() {

    this.contentReplace = () => {
      const productModalScroll = document.getElementById(
        "product-modal-scroll",
      );

      if (productModalScroll && this.scrollPosition) {
        productModalScroll.scrollTop = this.scrollPosition;
      }
    };

    swup.hooks.before("content:replace", () => {
      const productModalScroll = document.getElementById(
        "product-modal-scroll",
      );

      if (productModalScroll) {
        this.scrollPosition = productModalScroll.scrollTop;
      }
    });

    swup.hooks.on("content:replace", this.contentReplace);
  },
  async open(productUrl: string) {
    document.body.style.overflow = "hidden";
    this.productUrl = productUrl;
    this.createFragmentRules();

    await swup.navigate(this.productUrl, {
      animate: false,
      history: "push",
    });

    this.visible = true;
    await animate(
      "#product-modal",
      { opacity: [0, 1], y: [-48, 0] },
      { duration: 0.6, ease: "easeOut" },
    );
  },
  createFragmentRules() {
    fragmentPlugin.prependRule({
      from: [window.location.pathname, "/products/:handle"],
      to: ["/products/:handle", window.location.pathname],
      containers: ["#product-modal-content"],
      name: "product-modal-content",
    });
  },
  destroy() {
    fragmentPlugin.setRules(
      fragmentPlugin
        .getRules()
        .filter((rule) => !rule.name?.includes("product-modal")),
    );
  },
  async close(hasHistory = true, unlockScroll = true) {
    this.visible = false;
    await animate(
      "#product-modal",
      { opacity: [1, 0] },
      { duration: 0.5, ease: "linear" },
    );
    if (hasHistory) {
      history.back();
    }
    if (unlockScroll) {
      document.body.style.overflow = "auto";
    }
    this.destroy();
  },
  toggle() {
    if (this.visible) {
      this.close();
    } else {
      this.open();
    }
  },
};
